<template>
  <div class="sidebar-left">
    <div
      class="sidebar"
      :style="showLoader ? 'pointer-events: none; opacity: .5;' : ''"
    >
      <div class="sidebar-content email-app-sidebar">
        <div class="email-app-menu">
          <!-- Botones para emitir nueva notificación y actualizar -->
          <div class="form-group-compose text-center compose-btn">
            <b-row>
              <b-col cols="12">
                <b-button
                  v-b-tooltip.hover.top="'Genera una nueva notificación'"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  size="sm"
                  class="d-inline mr-25"
                  @click="$emit('update:show-notification-compose-modal', true); $emit('close-notification-view'); $emit('close-left-sidebar')"
                >
                  <feather-icon
                    icon="MessageSquareIcon"
                    class="mr-25"
                  />
                  Emitir notificación
                </b-button>
                <b-button
                  v-b-tooltip.hover.top="'Actualizar lista de notificaciones'"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  size="sm"
                  class="d-inline"
                  @click="$emit('reload-notification'); $emit('close-notification-view'); $emit('close-left-sidebar')"
                >
                  <feather-icon icon="RepeatIcon" />
                </b-button>
              </b-col>
            </b-row>
          </div>

          <!-- Filtros -->
          <vue-perfect-scrollbar
            :settings="perfectScrollbarSettings"
            class="sidebar-menu-list scroll-area"
          >
            <!-- Tipo de notificación -->
            <b-list-group class="list-group-messages">
              <b-list-group-item
                v-for="(filter, index) in folderFilters"
                :key="index"
                :class="folder == filter.folder ? 'cursor-default' : 'cursor-pointer'"
                :active="folder == filter.folder"
                @click="folder = filter.folder; $emit('change-folder', filter.folder); $emit('close-notification-view'); $emit('close-left-sidebar')"
              >
                <feather-icon
                  :icon="filter.icon"
                  size="18"
                  class="mr-75"
                />
                <span class="align-text-bottom line-height-1">{{ filter.title }}</span>
                <b-badge
                  v-if="notificacionesMeta[filter.folder]"
                  pill
                  :variant="resolveFilterBadgeColor(filter.folder)"
                  class="float-right"
                >
                  {{ notificacionesMeta[filter.folder] }}
                </b-badge>
              </b-list-group-item>

              <!-- Notificaciones que he emitido -->
              <b-list-group-item
                class="cursor-pointer"
                @click="$emit('update:show-emitted-notification-modal', true); $emit('close-notification-view'); $emit('close-left-sidebar')"
              >
                <feather-icon
                  icon="UserCheckIcon"
                  size="18"
                  class="mr-75"
                />
                <span class="align-text-bottom line-height-1">Mis notificaciones</span>
              </b-list-group-item>
            </b-list-group>

            <hr>

            <!-- Orden -->
            <h6 class="section-label mt-2 mb-1 px-2">
              Orden
            </h6>

            <b-list-group class="list-group-labels">
              <b-list-group-item
                v-for="(order, index) in orderFilters"
                :key="index"
                :class="isSortDesc == order.value ? 'cursor-default' : 'cursor-pointer'"
                :active="isSortDesc == order.value"
                @click="isSortDesc = order.value; $emit('change-order', order.value); $emit('close-notification-view'); $emit('close-left-sidebar')"
              >
                <feather-icon
                  :icon="order.icon"
                  size="18"
                  class="mr-75"
                />
                <span class="align-text-bottom line-height-1">{{ order.title }}</span>
              </b-list-group-item>
            </b-list-group>

            <!-- Prioridad -->
            <h6 class="section-label mt-2 mb-1 px-2">
              Prioridad
            </h6>

            <b-list-group class="list-group-labels">
              <b-list-group-item
                v-for="(label, index) in priorityFilter"
                :key="index"
                :class="prioridad == label.value ? 'cursor-default' : 'cursor-pointer'"
                :active="prioridad == label.value"
                @click="changePrioridad(label.value); $emit('close-notification-view'); $emit('close-left-sidebar')"
              >
                <span
                  class="bullet bullet-sm mr-1"
                  :class="`bullet-${label.color}`"
                />
                <span>{{ label.title }}</span>
                <b-badge
                  v-if="prioridad == label.value"
                  v-b-tooltip.hover.right="'Remover filtro'"
                  pill
                  variant="danger"
                  class="float-right cursor-pointer"
                >
                  <feather-icon icon="XIcon" />
                </b-badge>
              </b-list-group-item>
            </b-list-group>

            <!-- Dirigido a -->
            <h6 class="section-label mt-2 mb-1 px-2">
              Dirigido a
            </h6>

            <b-list-group class="list-group-labels">
              <b-list-group-item
                v-for="(item, index) in destinyFilter"
                :key="index"
                :class="destino == item ? 'cursor-default' : 'cursor-pointer'"
                :active="destino == item"
                @click="changeDestino(item); $emit('close-notification-view'); $emit('close-left-sidebar')"
              >
                <span class="ml-1">{{ item }}</span>
                <b-badge
                  v-if="destino == item"
                  v-b-tooltip.hover.right="'Remover filtro'"
                  pill
                  variant="danger"
                  class="float-right cursor-pointer"
                >
                  <feather-icon icon="XIcon" />
                </b-badge>
              </b-list-group-item>
            </b-list-group>
          </vue-perfect-scrollbar>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import {
  BButton,
  BListGroup,
  BListGroupItem,
  BBadge,
  VBTooltip,
  BRow,
  BCol,
} from 'bootstrap-vue'
import {
  ref,
} from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import useNotificacion from './useNotificacion'

export default {
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  components: {
    // BSV
    BButton,
    BListGroup,
    BListGroupItem,
    BBadge,
    BRow,
    BCol,

    // 3rd Party
    VuePerfectScrollbar,
  },
  props: {
    notificacionesMeta: {
      type: Object,
      required: true,
    },
  },
  setup(_, { emit }) {
    const { showLoader } = useNotificacion()
    const perfectScrollbarSettings = { maxScrollbarLength: 60, wheelPropagation: false }
    const folder = ref('unread')
    const prioridad = ref(null)
    const destino = ref(null)
    const isSortDesc = ref(true)

    const orderFilters = [
      { title: 'Descendente', icon: 'ArrowDownIcon', value: true },
      { title: 'Ascendente', icon: 'ArrowUpIcon', value: false },
    ]

    const folderFilters = [
      { title: 'Nuevas', icon: 'InfoIcon', folder: 'unread' },
      { title: 'Anteriores', icon: 'ClockIcon', folder: 'read' },
      { title: 'Todas', icon: 'InboxIcon', folder: 'all' },
    ]

    const priorityFilter = [
      { title: 'Baja', color: 'success', value: 'BAJA' },
      { title: 'Media', color: 'warning', value: 'MEDIA' },
      { title: 'Alta', color: 'danger', value: 'ALTA' },
    ]

    const destinyFilter = ['TODOS', 'PLAN', 'PERIODO', 'CURSO', 'ALUMNO', 'USUARIO', 'GRUPO']

    const changePrioridad = value => {
      if (prioridad.value === value) {
        prioridad.value = null
        emit('change-priority', null)
      } else {
        prioridad.value = value
        emit('change-priority', value)
      }
    }

    const changeDestino = value => {
      if (destino.value === value) {
        destino.value = null
        emit('change-destino', null)
      } else {
        destino.value = value
        emit('change-destino', value)
      }
    }

    const resolveFilterBadgeColor = filter => {
      const colors = {
        unread: 'light-danger', read: 'light-warning', all: 'light-primary',
      }

      return colors[filter] || 'light-secondary'
    }

    return {
      // UI
      perfectScrollbarSettings,
      resolveFilterBadgeColor,

      // Data
      folder,
      prioridad,
      destino,
      isSortDesc,

      // Method
      changePrioridad,
      changeDestino,

      // Filter & Labels
      priorityFilter,
      folderFilters,
      destinyFilter,
      orderFilters,

      // Loader
      showLoader,
    }
  },
}
</script>
